import { mb } from '../../Themes/utilities';
import { rem } from 'polished';
import Icon from '../../Icon';
import React from 'react';
import StatusBar from '../StatusBar';
import styled, { useTheme } from 'styled-components';
const ResponsiveLabel = styled.div `
  display: none;
  ${mb('l')} {
    display: block;
    margin-left: ${rem(12)};
  }
`;
const StatusBarCloseButton = ({ onClose }) => {
    const theme = useTheme();
    return (React.createElement(StatusBar.Button, { onClick: onClose },
        React.createElement(Icon, { name: "close", size: "l", color: theme.color.primary }),
        React.createElement(ResponsiveLabel, null, "Ukon\u010Di\u0165")));
};
export default React.memo(StatusBarCloseButton);
